import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LabelsModule } from '@core/components/labels/labels.module';

import { CoreCustomFormsModule } from '@core/custom-forms/components/custom-forms-components.module';

import { AppRouterModule } from '@app/router.module';

import { ProjectDetailsFormsMainComponent } from './main/main.component';


import { ProjectsDetailsHelpersModule } from '../helpers/helpers.module';
import { ProjectDetailsFormsListComponent } from './list/list.component';
import { ProjectDetailsFormsFillMainComponent } from './fill-main/fill-main.component';
import { ProjectDetailsFormsViewMainComponent } from './view-main/view-main.component';



@NgModule({
    imports: [
        CommonModule,
        AppRouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        HelpersModule,
        ProjectsDetailsHelpersModule,
        CoreCustomFormsModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ProjectDetailsFormsMainComponent,
        ProjectDetailsFormsListComponent,
        ProjectDetailsFormsFillMainComponent,
        ProjectDetailsFormsViewMainComponent
    ],
    exports: [
        ProjectDetailsFormsMainComponent,
        ProjectDetailsFormsFillMainComponent,
        ProjectDetailsFormsViewMainComponent
    ],

})
export class ProjectsDetailsCustomFormsModule { }
